import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-title-button',
  templateUrl: './title-button.component.html',
  styleUrls: ['./title-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TitleButtonComponent {}
